module.exports = __webpack_public_path__ + "img/1029.a1917082.jpg";